








import Vue from 'vue';

export default Vue.extend({
  props: {
    vertical: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    width: { type: [Number, String], default: undefined },
    height: { type: [Number, String], default: undefined },
  },
  data: () => ({
    isBeingResizedHorizontally: false,
    isBeingResizedVertically: false,
    style: {} as Record<string, string>,
  }),
  computed: {
    isBeingResized(): boolean {
      return this.isBeingResizedHorizontally || this.isBeingResizedVertically;
    },
  },
  watch: {
    height: {
      immediate: true,
      handler() {
        if (this.height) {
          this.$nextTick(() => {
            this.setHeight(this.height);
          });
        }
      },
    },
    width: {
      immediate: true,
      handler() {
        if (this.width) {
          this.$nextTick(() => {
            this.setWidth(this.width);
          });
        }
      },
    },
  },
  mounted() {
    document.body.addEventListener('pointermove', this.onPointerMove);
    document.body.addEventListener('mouseup', this.onMouseUp);
  },
  beforeDestroy() {
    document.body.removeEventListener('pointermove', this.onPointerMove);
    document.body.removeEventListener('mouseup', this.onMouseUp);
  },
  methods: {
    getDefaultSlotElement() {
      const defaultSlotFn = this.$scopedSlots.default ?? (() => []);
      const [defaultSlot] = defaultSlotFn(undefined) as any[];
      return this._.getElement(defaultSlot) as HTMLElement;
    },
    setWidth(value: number | string) {
      let width = value as string;
      if (typeof value === 'number') {
        width = `${value}px`;
      }
      this.$set(this.style, 'width', width);
      const slotEl = this.getDefaultSlotElement();
      slotEl.style.width = width;
      slotEl.style.minWidth = 'none';
      slotEl.style.maxWidth = 'none';
      slotEl.style.transition = 'width 0s, height 0s';
    },
    setHeight(value: number | string) {
      let height = value as string;
      if (typeof value === 'number') {
        height = `${value}px`;
      }
      this.$set(this.style, 'height', height);
      const slotEl = this.getDefaultSlotElement();
      slotEl.style.height = height;
      slotEl.style.minHeight = 'none';
      slotEl.style.maxHeight = 'none';
      slotEl.style.transition = 'width 0s, height 0s';
    },
    onPointerMove(e: MouseEvent) {
      if (this.isBeingResized) {
        const element = this._.getElement(this.$refs.resizable as Vue);
        if (element) {
          if (this.isBeingResizedHorizontally) {
            const width = `${e.pageX - element.getBoundingClientRect().left}px`;
            this.setWidth(width);
          }
          if (this.isBeingResizedVertically) {
            const height = `${e.pageY - element.getBoundingClientRect().top}px`;
            this.setHeight(height);
          }
        }
      }
    },
    onMouseUp(e: MouseEvent) {
      e.preventDefault();
      this.isBeingResizedVertically = false;
      this.isBeingResizedHorizontally = false;
    },
    onMouseDownBoth(e: MouseEvent) {
      e.preventDefault();
      this.isBeingResizedHorizontally = true;
      this.isBeingResizedVertically = true;
    },
    onMouseDownHorizontally(e: MouseEvent) {
      e.preventDefault();
      this.isBeingResizedHorizontally = true;
    },
    onMouseDownVertically(e: MouseEvent) {
      e.preventDefault();
      this.isBeingResizedVertically = true;
    },
  },
});
